
export default {
  props: {
    texte: {
      type: String,
      required: true
    },
    cible: {
      type: String,
      required: true
    }
  },
  methods: {
    allerAncre () {
      const url = `https://${location.host}${location.pathname}`
      location.href = `${url}#${this.cible}`
    }
  }
}

